(() => {
  'use strict';
  const handles = Object.freeze(['spoon', 'difold-bottle-v2', 'difold-cup']);
  function missingHandles(cartHandles) {
    if (!Array.isArray(cartHandles)) return [];
    const present = new Set(cartHandles.filter(handle => handles.includes(handle)));
    return (present.has('spoon') || present.has('difold-bottle-v2')) && !present.has('difold-cup') ? ['difold-cup'] : [];
  }
  function itemHandles(items) {
    return Array.isArray(items) ? items.map(item => item.handle || item.product?.handle || String(item.url || '').match(/\/products\/([^/?#]+)/)?.[1]).filter(Boolean) : [];
  }
  const cupSelection = (product, id, config, context, api) => {
    const variant = product?.variants?.find(value => String(value.id) === String(id));
    const pool = config?.pools?.find(value => String(value.variantId).split('/').pop() === String(id));
    if (product?.handle !== 'difold-cup' || variant?.available !== true || !pool || pool.productHandle !== product.handle
      || (pool.storefrontProductHandle && pool.storefrontProductHandle !== product.handle) || pool.pool !== 'ready' || pool.spoon !== false || pool.dispatchDate !== null) return null;
    const selection = { id: String(id), quantity: 1, acceptedDispatchDate: null, properties: {} };
    try { return { selection, plan: api.planCart(api.createCatalog(config, [product], context), [selection], 'together') }; } catch { return null; }
  };
  const retainAddFocus = button => {
    const doc = button.ownerDocument;
    if (doc.activeElement !== button) return () => {};
    let moved = false;
    const onFocus = event => { if (event.target !== button && event.target !== doc.body) moved = true; };
    doc.addEventListener('focusin', onFocus);
    return () => {
      doc.removeEventListener('focusin', onFocus);
      if (moved || !button.isConnected || (doc.activeElement !== button && doc.activeElement !== doc.body)) return;
      const drawer = button.closest('dialog[data-native-drawer]');
      if (!drawer?.open) return;
      const target = [button, drawer.querySelector('[data-native-checkout]'), drawer.querySelector('[data-native-drawer-close]')]
        .find(element => element && !element.disabled && !element.closest('[hidden],[inert]') && element.getClientRects().length);
      target?.focus({ preventScroll: true });
    };
  };
  const helpers = Object.freeze({ missingHandles, itemHandles, cupSelection });
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof window === 'undefined') return;
  window.PolygonsCartUpsell = helpers;
  if (customElements.get('polygons-cart-upsell')) return;
  customElements.define('polygons-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.mode = this.dataset.mode === 'preview' ? 'preview' : 'cart';
      this.onState = event => {
        if (event.detail?.mode === this.mode) this.update(event.detail.handles);
      };
      this.onChoose = event => {
        const link = event.target.closest('[data-upsell-choose="spoon"]');
        if (!link || this.mode !== 'preview' || !/\/products\/spoon\/?$/.test(location.pathname)) return;
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('polygons:preview-upsell-choose', { detail: { handle: 'spoon' } }));
      };
      document.addEventListener('polygons:cart-state', this.onState);
      this.addEventListener('click', this.onChoose);
      this.setupCup();
      if (this.mode === 'cart' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (Array.isArray(event.cartData?.items)) this.update(itemHandles(event.cartData.items));
        });
      }
      this.update(this.mode === 'cart' ? handles.filter(handle => this.dataset[handle === 'spoon' ? 'hasSpoon' : handle === 'difold-bottle-v2' ? 'hasBottle' : 'hasCup'] === 'true') : []);
      document.dispatchEvent(new CustomEvent('polygons:cart-state-request', { detail: { mode: this.mode } }));
    }
    disconnectedCallback() {
      document.removeEventListener('polygons:cart-state', this.onState);
      this.removeEventListener('click', this.onChoose);
      this.unsubscribeCart?.();
      this.connected = false;
      this.cupForm?.removeEventListener('submit', this.onCupAdd);
      this.cupForm?.removeEventListener('click', this.onCupColor);
      this.cupSelect?.removeEventListener('change', this.onCupChange);
    }
    setupCup() {
      const card = this.querySelector('[data-upsell-handle="difold-cup"]');
      this.cupForm = card?.querySelector('[data-upsell-form]');
      this.cupSelect = card?.querySelector('[data-upsell-variant]');
      if (!this.cupForm || !this.cupSelect) return;
      let product, strings;
      try { product = JSON.parse(card.querySelector('[data-upsell-product]').textContent); strings = JSON.parse(card.querySelector('[data-upsell-strings]').textContent); } catch { return; }
      const button = card.querySelector('[data-upsell-add]'), output = card.querySelector('[data-upsell-notice]');
      const context = window.PolygonsNativeContext, config = window.PolygonsNativeCommerceConfig, api = window.PolygonsNativeCommerce;
      let busy = false;
      const swatches = card.querySelector('[data-upsell-swatches]'), colorName = card.querySelector('[data-upsell-color-name]');
      if (swatches) { swatches.hidden = false; this.cupSelect.hidden = true; colorName.hidden = false; }
      const selected = () => cupSelection(product, this.cupSelect.value, config, context, api);
      const render = () => {
        const variant = product.variants.find(value => String(value.id) === this.cupSelect.value), accepted = selected();
        button.disabled = busy || !accepted;
        this.cupSelect.disabled = busy;
        if (colorName) colorName.textContent = variant?.title || '';
        for (const swatch of card.querySelectorAll('[data-upsell-color]')) { swatch.disabled = busy; swatch.setAttribute('aria-pressed', String(swatch.dataset.upsellColor === this.cupSelect.value)); }
        button.textContent = busy ? strings.adding : variant?.available !== true ? strings.soldOut : accepted ? strings.add : strings.unavailable;
        if (variant && context?.currencyCode) card.querySelector('[data-upsell-price]').textContent = new Intl.NumberFormat(context.locale || 'en', { style: 'currency', currency: context.currencyCode }).format(variant.price / 100);
        const image = card.querySelector('.polygons-cart-upsell__image img'), source = variant?.featured_image?.src || variant?.featured_image?.url;
        if (image && typeof source === 'string' && /^(?:https:\/\/|\/\/|\/(?!\/))/.test(source)) { image.src = source; image.removeAttribute('srcset'); image.alt = `${product.title}: ${variant.title}`; }
      };
      this.onCupChange = () => { output.hidden = true; render(); };
      this.onCupColor = event => { const swatch = event.target.closest('[data-upsell-color]'); if (!swatch || busy) return; this.cupSelect.value = swatch.dataset.upsellColor; this.onCupChange(); };
      this.onCupAdd = async event => {
        event.preventDefault(); event.stopPropagation();
        const value = selected(); if (busy || !value) return;
        const restoreAddFocus = retainAddFocus(button);
        busy = true; output.hidden = true; render(); window.PolygonsNativeWallets?.invalidate();
        try {
          const surface = this.closest('[data-native-cart]');
          const view = surface?.polygonsNativeCartView;
          const result = view ? await view.add(value.selection) : await window.PolygonsNativeCart.createBrowserController(api, config, context).add(value.selection);
          if (!result?.cart) throw new Error(strings.error);
          this.update(window.PolygonsNativeCart.cartHandles(config, result.cart));
          if (await window.PolygonsNativeDrawer?.open({ state: result, trigger: button })) return;
          location.assign((context.root || '/').replace(/\/?$/, '/') + 'cart');
        } catch (cause) { output.textContent = cause.message || strings.error; output.hidden = false; }
        finally { busy = false; render(); restoreAddFocus(); }
      };
      this.cupSelect.addEventListener('change', this.onCupChange);
      this.cupForm.addEventListener('submit', this.onCupAdd);
      this.cupForm.addEventListener('click', this.onCupColor);
      render();
    }
    update(cartHandles) {
      const missing = missingHandles(cartHandles);
      let visible = false;
      for (const card of this.querySelectorAll('[data-upsell-handle]')) {
        card.hidden = !missing.includes(card.dataset.upsellHandle);
        visible ||= !card.hidden;
      }
      this.hidden = !visible;
    }
  });
})();
